import React, { FC } from "react";
import { propTypes } from "react-bootstrap/esm/Image";

const ValidationError = ({ field, touched, errors, children }: any) => {
  const touch = touched ? touched[field] : {};
  const error = errors ? errors[field] : {};

  return (
    <>
      {touch && error ? (
        <div className=" text-danger-light fs-8 pt-2 "> {children} </div>
      ) : null}
    </>
  );
};

export default ValidationError;
